import { useState, useRef, useEffect } from "react";
import { Globe, ChevronDown } from "lucide-react";
import { useLang, SUPPORTED_LANGS, LANG_NAMES } from "@/context/LangContext";

export default function LanguageSelect({ compact = false }) {
  const { lang, t } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  return (
    <div ref={ref} className="relative" data-testid="language-select">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label={t("foot.language")}
        data-testid="language-select-btn"
        className="flex items-center gap-1.5 rounded-full border border-white/10 bg-surface/60 px-3 py-1.5 text-xs font-bold text-muted-foreground transition-colors duration-200 hover:text-neon hover:border-neon/40"
      >
        <Globe className="h-3.5 w-3.5" />
        {compact ? lang.toUpperCase() : LANG_NAMES[lang]}
        <ChevronDown className={`h-3 w-3 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <ul
          role="listbox"
          aria-label={t("foot.language")}
          className="absolute bottom-full mb-2 end-0 z-50 max-h-72 w-44 overflow-y-auto rounded-xl border border-white/10 bg-void/95 backdrop-blur-xl p-1 shadow-2xl"
        >
          {SUPPORTED_LANGS.map((code) => (
            <li key={code}>
              <a
                role="option"
                aria-selected={code === lang}
                href={code === "ar" ? "/" : "/en/"}
                data-testid={`lang-option-${code}`}
                className={`block rounded-lg px-3 py-2 text-sm transition-colors duration-150 ${
                  code === lang ? "bg-neon/15 text-neon font-bold" : "text-muted-foreground hover:bg-white/5 hover:text-ice"
                }`}
              >
                {LANG_NAMES[code]}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
